import { createContext, useContext, useReducer } from "react";

const AuthContext = createContext(null);

const AUTH_KEY = "demo_shop_auth";

function loadPersistedUser() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function authReducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem(AUTH_KEY, JSON.stringify(action.member));
      return action.member;
    case "LOGOUT":
      localStorage.removeItem(AUTH_KEY);
      return null;
    default:
      return state;
  }
}

export function AuthProvider({ children }) {
  const [member, dispatch] = useReducer(authReducer, null, loadPersistedUser);

  return (
    <AuthContext.Provider value={{ member, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuthContext must be inside AuthProvider");
  return ctx;
}
